import React from 'react';
import { Tooltip } from 'antd';
import { TagColored } from '@spark';
import TaggedSample from '@/features/evaluation/components/TaggedSample';
import { countByLabel } from '@/features/datasets/components/DataSelection/ExtraParamsUtils';
import { getSparkTagVariant } from '@/features/datasets/components/DataSelection/sparkLabelColors';

/**
 * Read-only preview of a cross-referenced `entities` column.
 * Shows per-label type + count badges in the cell, and on hover the source
 * text with inline color-coded entity highlights (reusing the evaluation
 * TaggedSample renderer).
 *
 * Uses antd Tooltip because it renders complex JSX content (TaggedSample) —
 * Spark TooltipTrigger only supports text.
 */
export const EntitiesPreviewCell = ({ entities = [], text = '', allLabels = [] }) => {
    if (!Array.isArray(entities) || entities.length === 0) {
        return <span>No entities</span>;
    }

    const counts = countByLabel(entities, (e) => e.label);

    const badges = (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {Object.entries(counts).map(([label, count]) => (
                <TagColored
                    key={label}
                    label={`${label} (${count})`}
                    variant={getSparkTagVariant(label, allLabels)}
                />
            ))}
        </div>
    );

    return (
        <Tooltip
            title={
                <TaggedSample
                    text={text}
                    entities={entities}
                    allLabels={allLabels}
                    isGroundTruth
                    disableCard
                    suppressWrongLocationMessage
                />
            }
            placement="top"
            color="#ffffff"
            overlayInnerStyle={{ background: '#ffffff', padding: 15, borderRadius: 8, color: '#000000' }}
            overlayStyle={{ maxWidth: 480 }}
        >
            {badges}
        </Tooltip>
    );
};

export default EntitiesPreviewCell;
